import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";

import CustomModal from "../../CustomModal";

const ChallengeProjectGoalModal = forwardRef(({}, ref) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [projectData, setProjectData] = useState(null);

  useImperativeHandle(ref, () => ({
    openModal(projectData) {
      setProjectData(projectData);
      setIsOpen(true);
    },
    closeModal() {
      setIsOpen(false);
    },
  }));

  function formatProjectGoal(goal) {
    if (!goal) return "";

    const lines = goal.split(/\r?\n/);
    let count = 1;

    const formattedLines = lines.map((line) => {
      if (line.trim().startsWith("•")) {
        return `<strong>${count++}.</strong> ${line.replace("•", "").trim()}`;
      }
      return line;
    });

    return formattedLines.join("<br>");
  }

  return (
    <CustomModal
      isOpen={isOpen}
      withCloseButton={false}
      onClose={() => setIsOpen(false)}
      className="max-w-[55rem] rounded-2xl border-8 border-blue-500 !bg-[#F1F1F1] shadow-xl"
      contentClassname="p-6 bg-[#F1F1F1] px-20 !m-3"
    >
      <div className="my-4 text-center text-3xl font-bold text-blue-500">{projectData?.name}</div>

      <div className="mb-2 text-justify text-xl font-bold text-blue-500">{t("project_goal")}:</div>
      <div className="mb-6 text-justify text-blue-500">
        <p
          className="mb-2 font-medium"
          dangerouslySetInnerHTML={{
            __html: formatProjectGoal(projectData?.challenge_statement || t("no_project_goal")),
          }}
        ></p>
      </div>

      <div className="mb-6 flex w-full justify-center">
        {projectData?.image && (
          <img
            src={projectData?.image}
            className="h-60 w-96 rounded-3xl border border-gray-300 bg-blue-100"
            alt=""
          />
        )}
      </div>

      <div className="text-center">
        <button
          onClick={() => setIsOpen(false)}
          className="wavy-btn relative mb-6 mt-1 w-1/2 rounded-3xl border-4 border-[#ffe4af] bg-orange-500 p-4 text-lg font-semibold text-white transition duration-200"
        >
          {t("lets_code")}
        </button>
      </div>
    </CustomModal>
  );
});

export default ChallengeProjectGoalModal;
